"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
  updateBillingSettingsAction,
  type BillingSettingsView,
} from "@/server-actions/billing-settings"
import { billingSettingsQueryKey } from "@/hooks/queries/billing-settings"
import { withQueryHandling } from "@/lib/with-query-handling"

export function useUpdateBillingSettingsViewMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (input: {
      dailySpendingLimitMicrousd: number | null
      monthlySpendingLimitMicrousd: number | null
      lowBalanceThresholdMicrousd: number | null
      lowBalanceEmailEnabled: boolean
      spendingCapEmailEnabled: boolean
    }): Promise<BillingSettingsView> => {
      const result = await withQueryHandling(updateBillingSettingsAction(input), {
        loading: "Saving balance alerts...",
        success: "Balance alerts saved",
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
    onSuccess: async (data) => {
      queryClient.setQueryData(billingSettingsQueryKey, data)
      // The banner's "low" flag is computed from the same threshold — refetch it
      // so the UI cannot show a low-balance warning at a number the tenant just
      // changed away from.
      await queryClient.invalidateQueries({ queryKey: ["billing"] })
    },
  })
}
